import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './Overview.styles';
import { getOverviewData } from './Overview.helpers';
import { OverviewData } from './Overview.types';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { useAdDetails } from '@/hooks/useAdDetails';
import NoSsr from '@/components/NoSsr/NoSsr';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import { useServerDataContext } from '@/contexts';
import { getMessageTime } from '@/utils/datetime.utils';

export const Overview: React.FC = () => {
  const { i18n } = useTranslation();
  const { adDetails } = useAdDetails();
  const { initialAdDetails } = useServerDataContext();
  const adData = adDetails ?? initialAdDetails;
  const overviewData = adData
    ? getOverviewData(i18n, adData)
    : Array.from({ length: 3 }, (_, index) => ({ id: index } as OverviewData));

  return (
    <S.Box {...(!adData && { 'data-testid': 'overview-skeleton-loader' })}>
      {overviewData.map(({ id, name, value }) =>
        name ? (
          <S.Item key={id}>
            <S.Name>{name}</S.Name>
            <Typography.Body>{value}</Typography.Body>
          </S.Item>
        ) : (
          <S.Item key={id}>
            <SkeletonLoader height="18px" />
            <SkeletonLoader height="18px" />
          </S.Item>
        )
      )}
      <NoSsr>
        <S.Item>
          <S.Name>{i18n.t('pages.ad.updated')}</S.Name>
          {adData?.updatedAt ? (
            <Typography.Body>
              {getMessageTime(new Date(adData.updatedAt), i18n, true)}
            </Typography.Body>
          ) : (
            <SkeletonLoader height="18px" />
          )}
        </S.Item>
      </NoSsr>
    </S.Box>
  );
};
